import { Link } from "react-router-dom";
import { GetGastos } from "../../actions/Gastos.jsx";
import { GotoLogin } from "../../actions/renovarLog";
import { Pencil, SquareX, CirclePlus } from "lucide-react";

import style from "../../styles/grid.module.css";

import { useMutation } from "@tanstack/react-query";

import { formatos } from "../../actions/formats.jsx";

const AbmGastos = () => {
   const { formatoNumero } = formatos();
   const hoy = new Date();
   const url = process.env.REACT_APP_URL_DIR + "gasto";
   const token = localStorage.getItem("token");
   const gastos = GetGastos();

   const { mutate } = useMutation({
      mutationFn: (id) =>
         fetch(url + "/" + id, {
            method: "DELETE",
            body: JSON.stringify(),
            headers: {
               Authorization: `Bearer ${token}`,
               "Content-Type": "application/json",
            },
         }).then((res) => res.json()),
      onSuccess: (res) => {
         if (res?.message) {
            alert(`Aviso : ${res.message}`);
         }
         window.location.href = "/gasto";
      },
      onError: (error) => {
         alert(error);
      },
   });

   const handleRemove = async (id) => {
      let text =
         "Se va a eliminar el gasto selecionado!\nSelecione Aceptar or Cancelar.";
      if (window.confirm(text) === true) {
         mutate(id);
         window.location.href = "/gasto";
      }
   };

   const formatDate = (fecha) => {
      var newDate1 = fecha.substring(0, 10).split("-");
      var newdate2 = newDate1[2] + "/" + newDate1[1] + "/" + newDate1[0];
      return newdate2;
   };

   if (gastos?.message === "Token inválido") {
      return <GotoLogin />;
   }
   console.log("gastos: ", gastos);
   return (
      <>
         <div className={style.tableCli}>
            <div>
               <div>
                  <div className={style.gridTitle}>
                     <h2>Gastos</h2>
                  </div>
               </div>
               <div>
                  <div>
                     <Link
                        to={"/formGasto"}
                        className="dLink"
                        title="Alta Compra"
                        state={{
                           id_primary: 0,
                           id: 0,
                           fecha: hoy.toISOString().split("T")[0],
                           companyId: 0,
                           titulo: "",
                           total: 0,
                           cod_status: 1,
                           gastodets: [],
                        }}
                     >
                        <CirclePlus className="lucidePlus" />
                     </Link>
                  </div>
               </div>
               &nbsp;&nbsp;
            </div>
         </div>
         <div>
            <table className={style.smallgridTable}>
               <thead>
                  <tr>
                     <th>Fecha</th>
                     <th>Descripcion</th>
                     <th>Total</th>
                     <th>Acciones</th>
                  </tr>
               </thead>
               <tbody>
                  {gastos &&
                     gastos?.map((insu) => {
                        return (
                           <tr
                              key={insu.id}
                              className={
                                 parseInt(insu.cod_status) === 2
                                    ? style.trdatosRed
                                    : style.trdatos
                              }
                           >
                              <td className={style.style_code}>
                                 {formatDate(insu.fecha)}
                              </td>
                              <td className={style.style_td}>{insu.titulo}</td>
                              <td style={{textAlign: "right"}}>$ {formatoNumero(insu.total)}</td>
                              <td className={style.aligncenter}>
                                 <Link
                                    to={"/formGasto"}
                                    className="dLink"
                                    state={{
                                       id_primary: insu.id_primary,
                                       id: insu.id,
                                       companyId: insu.companyId,
                                       fecha: insu.fecha.substring(0, 10),
                                       titulo: insu.titulo,
                                       total: insu.total,
                                       cod_status: insu.cod_status,
                                       gastodets: insu.detalles,
                                    }}
                                 >
                                    <Pencil className="lucideIcon" />
                                 </Link>
                                 &nbsp;&nbsp;
                                 <span
                                    className="lucideIconDel"
                                    title="Eliminar cliente"
                                 >
                                    <SquareX
                                       className="lucideIconDel"
                                       onClick={() => handleRemove(insu.id)}
                                    />
                                 </span>
                              </td>
                           </tr>
                        );
                     })}
               </tbody>
            </table>
         </div>
      </>
   );
};

export default AbmGastos;
